import { createAppAsyncThunk } from 'app/redux/utils/thunk-utils';
import { AuthInfo } from 'app/pages/auth/model/auth-info';
import { AuthService } from 'app/pages/auth/service/auth-service';

interface FetchAccessTokenCreatorPayload {
    code: string;
    stateParam: string;
}

export const fetchAccessTokenActionCreator = createAppAsyncThunk<AuthInfo, FetchAccessTokenCreatorPayload>(
    'auth/fetchAccessToken',
    async ({ code, stateParam }, { getState }) => {
        const {
            auth: { authenticationKey, codeVerifier },
        } = getState();

        if (!codeVerifier) {
            throw new Error('Invalid state. Code verifier must be present.');
        }

        if (stateParam !== authenticationKey) {
            throw new Error('Authentication state and randomly generated key do not match');
        }

        return AuthService.fetchAccessToken(code, codeVerifier);
    },
);
